import Box from '@zenbusiness/zui/Box';
import Card from '@zenbusiness/zui/Card';
import Stack from '@zenbusiness/zui/Stack';
import { styled } from '@zenbusiness/zui/styles';

export const DialogCard = styled(Card)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  padding: theme.spacing(2),
  gap: theme.spacing(2),
  borderRadius: theme.shape.rounded['2xl'],

  [theme.breakpoints.up('lg')]: {
    padding: theme.spacing(3, 3, 4),
  },
}));

export const CardTop = styled(Stack)(({ theme }) => ({
  flexDirection: 'column',
  alignItems: 'flex-start',

  [theme.breakpoints.up('lg')]: {
    flexDirection: 'row',
  },
}));

export const CardTitle = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column-reverse',
  gap: theme.spacing(1),

  [theme.breakpoints.up('lg')]: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
}));

export const IconContainer = styled(Card)(({ theme }) => ({
  width: '3rem',
  minWidth: '3rem',
  height: '3rem',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: theme.shape.rounded.md,
}));

export const Item = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  padding: theme.spacing(1, 0),
}));
